import React from "react";
var InfoCircle = function InfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.5h4a1 1 0 1 0 0-2h-.75a.25.25 0 0 1-.16-.057l-.017-.016a.25.25 0 0 1-.073-.177V11.5a2 2 0 0 0-2-2h-1a1 1 0 1 0 0 2h.75a.25.25 0 0 1 .25.25v4.5a.3.3 0 0 1-.023.107.25.25 0 0 1-.227.143h-.75a1 1 0 1 0 0 2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.25",
    cy: "6.5",
    r: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12m0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5"
  }));
};
InfoCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
import createIconComponent from '../createIconComponent';
export const InfoCircleIcon = createIconComponent(InfoCircle, 'InfoCircle');